import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { LessonCreationStudiosVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveLessonCreationStudios = createAsyncThunk<LessonCreationStudiosVM, void, { extra: Partial<Dependencies> }>(
  "teacher/retrieve-lesson-creation-studios",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getLessonCreationStudios();
  },
);
